module.exports = __webpack_public_path__ + "img/maTouQin6.83d0afe2.png";